import {Component, OnInit, ViewChild} from '@angular/core';
import {IonSearchbar, ModalController, NavParams, Platform} from '@ionic/angular';
import {Router} from '@angular/router';
import {Estacao} from 'src/app/shared/models/estacao.model';
import {FormControl} from '@angular/forms';
import {debounceTime, map} from 'rxjs/operators';
import {EstacaoService} from '../../shared/services/estacao.service';
import {removeAcentos} from '../../shared/util/format';
import {BuscaService} from '../../shared/services/busca.service';
import {toast} from '../../shared/util/toast';
import {FavoritoService} from '../../shared/services/favorito.service';

@Component({
  selector: 'app-buscar-estacoes',
  templateUrl: './buscar-estacoes.component.html',
  styleUrls: ['./buscar-estacoes.component.scss'],
})
export class BuscarEstacoesComponent implements OnInit {
  todasEstacoes: Estacao[] = [];
  estacoesFiltradas: Estacao[];
  estacoesRecentes: Estacao[] = [];
  qtdResultados = 0;
  showMapFilter = true;
  buscarInput = new FormControl();
  isLoading = false;
  isDesktop: boolean;
  isPrincipal: boolean;
  prefixoRota: string;
  @ViewChild('searchbar', {static: false}) searchbar: IonSearchbar;

  set ordem(value) {
    this.sortEstacoes(value);
  }

  constructor(
    public router: Router,
    public platform: Platform,
    private estacaoService: EstacaoService,
    private buscarProvider: BuscaService,
    private modalCtrl: ModalController,
    private favoritoService: FavoritoService,
    private navParams: NavParams
  ) {
    this.isPrincipal = this.navParams.get('isEstacaoPrincial');

    if (this.navParams.get('showMapFilter')) {
      this.showMapFilter = this.navParams.get('showMapFilter');
    }

    this.isDesktop = this.platform.is('desktop') &&
      !this.platform.is('mobile') &&
      !this.platform.is('mobileweb');
    this.prefixoRota = this.isDesktop ? '' : '/tabs';
    this.isLoading = true;
    this.estacaoService.getAll('todas').subscribe(
      estacoes => this.todasEstacoes = estacoes,
      error => {
        console.log(error);
        toast('Não foi possível retornar as estações');
      },
      () => this.isLoading = false
    );
  }

  ngOnInit() {
    this.buscarInput.valueChanges.pipe(
      map((value: string) => {
        this.isLoading = true;
        return value;
      }),
      debounceTime(1500)
    )
      .subscribe(
        value => this.filtrar(value)
      );
  }

  ionViewDidEnter() {
    setTimeout(() => this.searchbar.setFocus(), 500);
    this.buscarProvider.init().then((estacoes: any) => {
      estacoes.forEach(
        e => {
          this.estacoesRecentes.push(e);
        }
      );
    });
  }

  filtrar(filtro) {
    // @ts-ignore
    this.estacoesFiltradas = this.todasEstacoes.filter(estacao => {

        if (estacao && estacao.noEstacao && estacao.idEstacao) {

          if (!estacao.municipio) {
            return (removeAcentos(estacao.noEstacao.toUpperCase()).includes(removeAcentos(filtro.toUpperCase())) ||
              estacao.idEstacao.toString().includes(filtro));
          }
          return (removeAcentos(estacao.noEstacao.toUpperCase()).includes(removeAcentos(filtro.toUpperCase())) ||
            (estacao.municipio && estacao.municipio.noMunicipio && removeAcentos(estacao.municipio.noMunicipio.toUpperCase()).includes(removeAcentos(filtro.toUpperCase()))) ||
            (estacao.municipio && estacao.municipio.uf && removeAcentos((estacao.municipio.uf.noUf + estacao.municipio.uf.sgUf).toUpperCase()).includes(removeAcentos(filtro.toUpperCase()))) ||
            estacao.idEstacao.toString().includes(filtro));
        }
        return false;
      }
    );
    this.sortEstacoes();
    this.qtdResultados = this.estacoesFiltradas.length;
    this.isLoading = false;
  }

  localAtual() {
    this.dismiss({localAtual: true})
  }

  selecionarNoMapa() {
    this.dismiss({verNoMapa: true});
  }

  estacaoDetalhe(estacao: any) {
    if (this.isPrincipal) {
      estacao.isPrincipal = true;
      this.favoritoService.favoritarEstacao(estacao);
      this.dismiss();
      return;
    }
    this.buscarProvider.addEstacao(estacao);
    this.dismiss({estacao});
  }

  private sortEstacoes(ordem?) {
    if (!this.estacoesFiltradas) {
      return;
    }

    let funcSort;

    switch (ordem) {
      case Ordem.NomeDesc.toString() :
        funcSort = (a, b) => {
          if (a.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          }
          if (a.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '') > b.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          }
          return 0;
        };
        break;
      default:
        funcSort = (a, b) => {
          if (a.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '') > b.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return 1;
          }
          if (a.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '') < b.noEstacao.normalize('NFD').replace(/[\u0300-\u036f]/g, '')) {
            return -1;
          }
          return 0;
        };
    }

    this.estacoesFiltradas.sort(funcSort);

  }

  dismiss(data = null) {
    this.modalCtrl.dismiss(data);
  }

  cancelar() {
    this.dismiss(null);
  }

}

export enum Ordem { NomeAsc, NomeDesc, CodigoAsc, CodigoDesc };
